"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var execCommand_1 = require("../utils/execCommand");
/**
 * Toggle bold at selection
 * If selection is collapsed, it will only affect the following input after caret
 * If selection contains only bold text, the bold style will be removed
 * If selection contains only normal text, bold style will be added to the whole selected text
 * If selection contains both bold and normal text, bold stle will be added to the whole selected text
 * @param editor The editor instance
 */
function toggleBold(editor) {
    execCommand_1.default(editor, "bold" /* Bold */);
}
exports.default = toggleBold;
//# sourceMappingURL=toggleBold.js.map